import app from "app.controller"
import config from "config.js"
import { action, observable } from "mobx"
import $fetch from "sdk/$fetch"
import Filter from "sdk/filter/Filter"
import shop from "shop/shop"
import cmsStore from "stores/cmsStore"
import { encode } from "qs/lib/utils";
import {withRouter} from "react-router"
import categoryStore from "./categoryStore"
import languageStore          from "./languageStore"

const REACT_APP_API_VERSION = process.env.REACT_APP_API_VERSION || ""

// import _ from "lodash"
class ProductStore {

  @observable productById = new Map()
  @observable response = false
  @observable loading = false
  @observable currentCategory = false
  @observable searchByQuery = new Map()
  @observable lastSearchURL = ""
  @observable lastSearchResult = ""

  baseSearchUrl = `data/${REACT_APP_API_VERSION}
	/search`// data/v1/search is the new search Endpoint

  constructor() {
    this.filters = {}
    this.filters.category = new Filter().category( true )
  }

  state = {
    topseller: [],
    test: "",
    topsellerCategory:{
      categoryId: 0,
      meta: {},
      products: [],
      url: "",
      searchTerm: "",
      result: [],
      size: 0
    }
  }

  handleLoadTopseller = async () => {
		try{
			//shop/rest/data/inventories?start=0&count=50
			const response = await shop.fetch( `/shop/rest/data/topseller?count=20&customer=${shop.session.value.map_id}`, {
				method: "GET",
				credentials:"include",
			});
			console.log("TOPSELLER handleLoadTopseller", response)
		   
			if(response.value.length >= 1){
				response.result = response.value
				response.products = response.value.map( productData => new config.model.ProductModel( productData ) )
				shop.topseller = response
				console.log("TOPSELLER SHOP TOPSELLER", shop.topseller)
			}
			
		}
		catch (error) {
			console.error(error);
		}
	}

  @action
  get = ( id ) => {
    const url = config.API + "data/products/" + id + "?lang=" + app._currentLanguage
    //console.log("GET PRODUCT", url)
    return $fetch( url, {
      mode       : "cors",
      credentials: "include"
    } )
      .then( response => {
        if ( response && response.message ) {
          console.error( response.message )
          throw new Error( response.message )
        }
        const product = new config.model.ProductModel( response )
        this.productById.set( product.map_id, product )
        return product
      } )
      .catch( error => {
        console.warn( error )
        return false
      } )

  }

  async search( value, { filter, sort = "sort", dir, count, start, page = 1, artnr = "1", mainonly = 0, variants = 0 } = {}, { useArtNr } = {} ) {
    if ( useArtNr ) {
      console.log("Set SEARCH shop.config.plugin", shop.config.plugin)
      let search = await shop.fetchCached( `/shop/rest/data/search/typeahead?value=${value}&count=5&sort=${sort}&artnr=${artnr}${app.getQueryLanguageParameter()}` )
      if ( search.length === 1 ) {
        value = search[ 0 ].id
      }
    }
    console.log( "search::", value, { filter, sort, count, page } )
    count = count || this.shop.config.pageSize
    start = start || (page - 1) * count
    return this.query( {
      value,
      filter,
      sort,
      dir,
      count,
      start,
      artnr,
      mainonly,
      variants
    } )
  }

  async searchCategories( value, fetchCategoryData ) {
    const { currentLanguage } = languageStore
    let searchCategories = []
    if(fetchCategoryData){
      const keys = Object.keys(value);
      searchCategories = await Promise.all( keys.map( key => categoryStore.fetchCategoryMetaData(key) ) )
    }
    else{
      searchCategories = await shop.fetch(`/shop/rest/data/categories/search/?search=${value}&lang=${currentLanguage}&start=0&count=4`, {
        mode       : "cors",
        credentials: "include"
      } )
    }
    /*console.log("SEARCH CATEGORIES", searchCategories)
    if(searchCategories && searchCategories.length == 0){ 
      console.log("SEARCH CATEGORIES", searchCategories)
      searchCategories = await shop.fetch(`/shop/rest/data/v2/search?value=${value}&lang=${currentLanguage}&start=0&count=4&sort=des&dir=desc&artnr=0&mainonly=0&variants=0&lang=de`, {
        mode       : "cors",
        credentials: "include"
      } )
    }*/
    //searchCategories = await searchCategories.map( categoryData => categoryStore.fetchCategory(categoryData.map_id) )
    console.log("SEARCH CATEGORIES", searchCategories)
    if(searchCategories && searchCategories.length > 0 && !searchCategories[0].desc){
      searchCategories.desc = searchCategories.map( categoryData => categoryData.desc = categoryData.descs[currentLanguage])
    }
    console.log("SEARCH CATEGORIES", searchCategories)
    return searchCategories
  }

  @action
  partlist( id, usePost = false ) {
    let url = config.API + `data/partlists/${id}` + "?lang=" + app._currentLanguage
    //console.log( "FETCH PART LIST", url )
    return fetch( url, {
      mode       : "cors",
      credentials: "include"
    } )
      .then( res => res.json() )
      .then( variants => {
        // SOME LISTS ARE TOO LONG => USE POST REQUEST.
        if ( usePost ) {
          return this.listPost( variants.articles )
            .then( products => {
              return { products, variants }
            } )
        } else {
          return this.list( variants.articles )
            .then( products => {
              return { products, variants }
            } )
        }
      } )
      .catch( e => {
        console.error( "ERROR FETCHING PART LIST", e )
        return false
      } )
  }

  @action
  list( product_ids ) {
    if ( !Array.isArray( product_ids ) ) throw("list() expects an Array as its' sole argument")
    // /shop/rest/data/productlist?list=[100003,100004]
    let url = config.API + "data/productlist?list=" + encodeURIComponent(JSON.stringify( product_ids )) + "&lang=" + app._currentLanguage
    return fetch( url, {
      mode       : "cors",
      credentials: "include"
    } )
      .then( response => response.json() )
      .then( response => response.list )
      .then( response => {
        response = response.map( productData => new config.model.ProductModel( productData ) )
        return response
      } )
  }

  @action
  listPost( product_ids ) {
    if ( !Array.isArray( product_ids ) ) throw("list() expects an Array as its' sole argument")
    // /shop/rest/data/productlist?list=[100003,100004]
    let url = config.API + `data/productlist?` + app.getQueryLanguageParameter( "" )
    return $fetch( url, {
      mode       : 'cors',
      credentials: "include",
      method     : "POST",
      body       : JSON.stringify( product_ids )
    } )
      .then( response => response.list )
      .then( response => {
        response = response.map( productData => new config.model.ProductModel( productData ) )
        return response
      } )
  }


  /**
   * api.products.fromCategory(49) -> Get Products from category 49
   * @param value
   * @param sort
   * @param count
   * @param start
   * @returns {type[]}
   */
  @action
  fromCategory( value, { query = "%%", sort, dir, page = 1, count = 6, variants = "0", sub = "2" } = {}, filters ) {
    console.log( `===SEARCH CAT`, arguments, sub )
    let start = (page - 1) * count
    return this.query( {
      value : "%%",
      filter: filters ? [this.filters.category.query( value, sub ), ...filters] : this.filters.category.query( value, sub ),
      sort,
      dir,
      count,
      start,
      variants
    } )
      .then( res => {

        if ( !Array.isArray( value ) ) {
          res.categoryId = value
          this.currentCategory = res
        }
        return res
      } )
  }

  @action
  async fromTopseller( value, { query = "%%", sort, dir, page = 1, count = 6, variants = "0" } = {}, filters, sub ) {
    if(!value){ 
      value = "topseller"
    }
    console.log( `===SEARCH TOP`, arguments )
    let start = (page - 1) * count
    return this.queryTopseller( {
      value : "%%",
      filter: filters ? [this.filters.category.query( value, sub ), ...filters] : this.filters.category.query( value, sub ),
      sort,
      dir,
      count,
      start,
      variants
    } )
      .then( res => {

        if ( !Array.isArray( value ) ) {
          res.categoryId = value
          this.currentCategory = res
        }
        return res
      } )
  }


  typeahead() {

  }

  /**
   * [search description]
   * @param  {[type]} value  [description]
   * @param  {[type]} filter [description]
   * @param dir
   * @param  {String} sort   [description]
   * @param  {Number} count  [description]
   * @param  {Number} start  [description]
   * @param artnr
   * @param mainonly
   * @return {[type]}                [description]
   */
  @action
  query( { value, filter, dir = shop.config.standards.DIR || "desc", sort = shop.config.standards.SORT, count = shop.config.standards.ITEMS_PER_PAGE, start = 0, artnr = "0", mainonly = "0", variants = "0",page } ) {
    this.loading = true
    if ( filter && filter.length > 0 ) {
      filter = filter.map( filterPart => {
        console.log("FILTER PART", filterPart)
        if ( filterPart.or ) {
          let found = false
          let or = []
          filterPart.or.forEach( subPart => {
            let field = subPart.field
            let value = subPart.value

            let config = cmsStore.config[ field ]
            if ( config ) {
              found = true
              let valueConfig = config.filter( v => v.key === value )[ 0 ]
              if ( valueConfig && valueConfig.extras ) {
                if ( valueConfig.extras.replace_filter ) {
                  let replaceFilter = JSON.parse( valueConfig.extras.replace_filter )
                  if ( replaceFilter && replaceFilter.or ) {
                    replaceFilter.or.forEach( part => {
                      or.push( part )
                    } )
                    return
                  }
                }
              }
            }

            or.push( subPart )
          } )

          if ( found ) {
            filterPart.or = or
          }
        }

        return filterPart
      } )
    }

    if ( !value && !filter ) console.warn( "Invalid search term: ", value )
    if ( value.length < 3 && value !== "%%" ) {
      this.loading = false
      this.response = false
      return Promise.resolve( false )
    }
    if ( !(sort in sort_options) ) {
      console.warn( "Unkown sort mode. Use", sort_options )
    }
    // '?filter=%5B%7B"cats"%3A%5B"83"%5D%7D%5D&start=0&count=6&sort=article_nr&dir=asc&?lang=de'
    let filterSegment = ""
    if ( filter ) {
      // console.log( `filter:`, filter )
      if ( !Array.isArray( filter ) ) filter = [filter]
      let f = JSON.stringify( filter )
      console.log("filter", filter)
      filterSegment = "&filter=" + encodeURIComponent( f )
    }
    console.log("FILTER SEGMENT", filterSegment)

    let valueSegment = ""
    // if(value === "%%") value = "" // works with %% (legacy and problematic url-encoding)
    if ( value !== "%%" ) {
      valueSegment = "value=" + encodeURIComponent( value )
    } else {
      valueSegment = ""
    }
    
    let url = ""
    if(shop.config.plugin.fuzzySearch){
      url = config.API + this.baseSearchUrl + "?" + valueSegment + filterSegment + "&start=" + start + "&count=" + 20 + "&sort=" + sort + "&fuzzy=" + 1 + "&dir=" + dir + "&artnr=" + artnr + "&mainonly=" + mainonly + "&variants=" + variants + "&lang=" + app._currentLanguage
    }
    else{
      if(start == 0 && page != 1 && page != undefined){
        start = (page - 1) * count
      }
      url = config.API + this.baseSearchUrl + "?" + valueSegment + filterSegment + "&start=" + start + "&count=" + count + "&sort=" + sort + "&dir=" + dir + "&artnr=" + artnr + "&mainonly=" + mainonly + "&variants=" + variants + "&lang=" + app._currentLanguage
    }
    this.lastSearchURL = url
    console.log("URL", url)
    return $fetch( url, {
      mode       : "cors",
      credentials: "include"
    } )
      .then( response => {
        //console.log("RESPONSE", response)
        response.products = response.result.map( productData => new config.model.ProductModel( productData ) )
        response.url = url
        response.searchTerm = value
        this.response = response
        this.searchByQuery.set( url, response )
        this.loading = false
        this.lastSearchResult = response
        return response
      } )
    // .catch( ( err ) => {
    //   this.loading = false
    //   this.response = false
    //   notie.alert( { type: "error", text: "Ungültige Produktdaten" } )
    //   throw new Error( err )
    // } )
  }


  queryTopseller( { value, filter, dir = shop.config.standards.DIR || "desc", sort = shop.config.standards.SORT, count = shop.config.standards.ITEMS_PER_PAGE, start = 0, artnr = "0", mainonly = "0", variants = "0" } ) {
    this.loading = true
    if ( filter && filter.length > 0 ) {
      filter = filter.map( filterPart => {
        if ( filterPart.or ) {
          let found = false
          let or = []
          filterPart.or.forEach( subPart => {
            let field = subPart.field
            let value = subPart.value

            let config = cmsStore.config[ field ]
            if ( config ) {
              found = true
              let valueConfig = config.filter( v => v.key === value )[ 0 ]
              if ( valueConfig && valueConfig.extras ) {
                if ( valueConfig.extras.replace_filter ) {
                  let replaceFilter = JSON.parse( valueConfig.extras.replace_filter )
                  if ( replaceFilter && replaceFilter.or ) {
                    replaceFilter.or.forEach( part => {
                      or.push( part )
                    } )
                    return
                  }
                }
              }
            }

            or.push( subPart )
          } )

          if ( found ) {
            filterPart.or = or
          }
        }

        return filterPart
      } )
    }

    if ( !value && !filter ) console.warn( "Invalid search term: ", value )
    if ( value.length < 3 && value !== "%%" ) {
      this.loading = false
      this.response = false
      return Promise.resolve( false )
    }
    if ( !(sort in sort_options) ) {
      console.warn( "Unkown sort mode. Use", sort_options )
    }
    // '?filter=%5B%7B"cats"%3A%5B"83"%5D%7D%5D&start=0&count=6&sort=article_nr&dir=asc&?lang=de'
    let filterSegment = ""
    if ( filter ) {
      // console.log( `filter:`, filter )
      if ( !Array.isArray( filter ) ) filter = [filter]
      let f = JSON.stringify( filter )
      filterSegment = "&filter=" + encodeURIComponent( f )
    }

    let valueSegment = ""
    // if(value === "%%") value = "" // works with %% (legacy and problematic url-encoding)
    if ( value !== "%%" ) {
      valueSegment = "value=" + encodeURIComponent( value )
    } else {
      valueSegment = ""
    }

    let url = config.API + 'data/v2/search?&filter=%5B%7B%22cats%22%3A%5B%22003000000%22%5D%7D%5D&start=0&count=24&sort=article_nr&dir=desc&artnr=0&mainonly=0&variants=0&lang=de'
    this.lastSearchURL = url
    
    return $fetch( url, {
      mode       : "cors",
      credentials: "include"
    } )
      .then( response => {
        console.log("RESPONSE", response)
        
        if(shop.topseller && shop.topseller.products){
          response.products = shop.topseller.products
          response.result = shop.topseller.result
        }
        else{
          this.handleLoadTopseller()
        }
        response.products = response.result.map( productData => new config.model.ProductModel( productData ) )
        response.url = url
        response.searchTerm = value
        this.response = response
        this.searchByQuery.set( url, response )
        this.loading = false
        this.lastSearchResult = response
        return response
      } )
    // .catch( ( err ) => {
    //   this.loading = false
    //   this.response = false
    //   notie.alert( { type: "error", text: "Ungültige Produktdaten" } )
    //   throw new Error( err )
    // } )
  }
}

var sort_options = {
  article_nr      : true,
  "price&dir=desc": true,
  "price&dir=asc" : true,
  created         : true,
  des             : true,
  sort            : true,
  price           : true
}

const productStore = new ProductStore( config )
window.productStore = productStore // TODO DEBUG
export default productStore



// WEBPACK FOOTER //
// ./src/stores/productStore.js